import { Type } from 'typebox';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const SkinApplicationEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.skinApplication),
        medicine: Type.Optional(Type.String())
    })
]));
